import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { Micro as CoreMicro } from '@vds-core/typography';
import { TypographyConfig } from '../../index';
import MicroConfig from './config';
import { Fonts } from '../../fonts';
var propTypes = {
  /**
   * When passed, Micro typography will have bold font weight
   */
  bold: PropTypes.bool
};
var defaultProps = {
  bold: false
};

var Micro = function Micro(props) {
  function getFontWeight(typescale, bold) {
    return bold ? '700' : '400';
  }

  return /*#__PURE__*/React.createElement(CoreMicro, _extends({}, props, {
    getFontWeight: getFontWeight,
    typescale: TypographyConfig.getTypescale(),
    config: MicroConfig,
    fontsConfig: Fonts
  }));
};

Micro.propTypes = propTypes;
Micro.defaultProps = defaultProps;
export default Micro;